import React, { useEffect, useState } from "react";
import clsx from "clsx";
import HeroVideo from "./HeroVideo";
import {
  STRIPE_COMBINATION_READY_EVENT,
  STRIPE_COMBINATION_READY_STORAGE_KEY,
} from "../constants/homeChrome";
import { isHomePathname } from "../utils/homePath";

/**
 * Mounted once via wrapPageElement so the hero <video> survives home → subpage → home.
 */
export default function PersistentHomeHero({ location }) {
  const isHome = isHomePathname(location?.pathname);
  const [stripeReady, setStripeReady] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }
    if (window.sessionStorage.getItem(STRIPE_COMBINATION_READY_STORAGE_KEY) === "1") {
      setStripeReady(true);
    }
    const onReady = () => setStripeReady(true);
    window.addEventListener(STRIPE_COMBINATION_READY_EVENT, onReady);
    return () => window.removeEventListener(STRIPE_COMBINATION_READY_EVENT, onReady);
  }, []);

  const stripeCombinationReady = !isHome || stripeReady;

  return (
    <div
      className={clsx(
        "persistent-home-hero",
        !isHome && "persistent-home-hero--off-route",
      )}
      aria-hidden={!isHome}
    >
      <HeroVideo
        prefersReducedMotion={false}
        stripeCombinationReady={stripeCombinationReady}
        playbackActive={isHome}
      />
    </div>
  );
}
